const isTouchDevice = () => {
  if (typeof window === 'undefined') {
    if (process.env.NODE_ENV === 'development') {
      console.log(
        'Hey! You are running the isTouchDevice function in the Server Side, it will only work in the client side.',
      );
    }
    return false;
  }
  const regx = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|DEV-Native-ios/i;

  return regx.test(navigator.userAgent);
};

export default isTouchDevice;
